/* eslint-disable vue/no-textarea-mustache */
<template>

  <div>
    <h1 class="title">AML self-assessment for Estate and Letting Agencies</h1>
  </div>
  <div v-if="!isHidden">
    <div class="container">
      <ul class="nav nav-tabs nav-justified">

        <!-- tabs -->

        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('policies')" :class="{ active: isActive('policies') }"
            href="#policies">Policies</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('risk')" :class="{ active: isActive('risk') }" href="#risk">Risk
            Assessments</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('staff')" :class="{ active: isActive('staff') }"
            href="#staff">Staff Training</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('cdd')" :class="{ active: isActive('cdd') }"
            href="#cdd">Customer Due Diligence</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" @click.prevent="setActive('reporting')" :class="{ active: isActive('reporting') }"
            href="#reporting">Reporting & Record Keeping</a>
        </li>
      </ul>



      <!-- tab policy -->


      <div class="tab-content py-3" id="myTabContent">
        <div class="tab-pane fade" :class="{ 'active show': isActive('policies') }" id="policies">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">

                      <label class="form-check-label fs16" for="check1">Q1.1 Does the firm have written policies,
                        controls and procedures to mitigate the risk of money laundering?</label> 
                        
                                             
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check1" v-model="checkedNumbers[0]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check2">Q1.2 Have the policies, controls and procedures
                        been tailored to the specific circumstances of the firm (structure, services provided, client
                        types, etc)?  </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check2" v-model="amberNumbers[0]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check3">Q1.3 Do the policies, controls and procedures
                        cover risk management practices, internal controls, customer due diligence, reliance and record
                        keeping and monitoring/management of compliance?
                      </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check3" v-model="checkedNumbers[2]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check4">Q1.4 Are the policies, controls and procedures
                        reviewed and updated regularly and is this approved by someone senior in the firm? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check4" v-model="checkedNumbers[3]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check5">Q1.5 Have the policies, controls and procedures
                        been communicated to staff, readily available for reference by all staff and is there evidence
                        of this? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check5" v-model="checkedNumbers[4]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>



              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check6">Q1.6 Has the firm designated a member of its
                        management team to be responsible for compliance with the Regulations (this may be the same as
                        the MLRO)? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check6" v-model="checkedNumbers[5]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>



              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check7">Q1.7 Has the designated member of the management
                        team been registered with and approved by HMRC? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check7" v-model="checkedNumbers[6]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>



              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check8">Q1.8 If the firm is part of a group or has
                        separate departments, are policies, controls and procedures consistently applied across all
                        parts of the group / departments? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check8" v-model="amberNumbers[1]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>





              <div class="row justify-content-end">
                <div class="col-2">
                  <div class="d-grid">
                    <a class="btn btn-outline-success" @click.prevent="setActive('risk')"
                      :class="{ active: isActive('risk') }" href="#risk">Next</a>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>


        <!-- tab risk -->


        <div class="tab-pane fade" :class="{ 'active show': isActive('risk') }" id="risk">
          <div class="container">
            <div class="row">



              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check29">Q2.1 Has the firm carried out a risk assessment
                        on itself?</label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check29" v-model="checkedNumbers[8]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>



              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check9">Q2.2 Does the firm’s risk assessment cover risks
                        associated with the clients; the countries and geographic areas in which it operates; the
                        services provided to clients; the types of transactions undertaken and how it delivers its
                        services? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check9" v-model="checkedNumbers[9]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check10">Q2.3 Has the firm considered the high-risk
                        factors disclosed by HMRC?</label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check10" v-model="amberNumbers[2]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check11">Q2.4 Has the firm reviewed and updated this
                        risk
                        assessment to make sure it is up to date in the last 12 months? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check11" v-model="checkedNumbers[11]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check12">Q2.5 Has the firm documented this risk
                        assessment?</label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check12" v-model="checkedNumbers[12]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check13">Q2.6 Has the firm’s risk assessment been
                        approved by senior management? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check13" v-model="checkedNumbers[13]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>




              <div class="row justify-content-between">


                <div class="col-2">
                  <div class="d-grid">
                    <a class="btn btn-outline-success" @click.prevent="setActive('policies')"
                      :class="{ active: isActive('policies') }" href="#policies">Previous</a>
                  </div>
                </div>

                <div class="col-2">
                  <div class="d-grid">
                    <a class="btn btn-outline-success" @click.prevent="setActive('staff')"
                      :class="{ active: isActive('staff') }" href="#staff">Next</a>
                  </div>
                </div>

              </div>





            </div>
          </div>
        </div>




        <!-- tab staff -->


        <div class="tab-pane fade" :class="{ 'active show': isActive('staff') }" id="staff">
          <div class="container">
            <div class="row">




              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check14">Q3.1 Have you provided adequate up-to-date
                        training for all staff? This training should include training in data protection relevant to the
                        Regulations. </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check14" v-model="checkedNumbers[14]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>



              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check15">Q3.2 Do you have a record of the training
                        provided?</label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check15" v-model="checkedNumbers[15]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check16">Q3.3 Have you made all staff aware of who the
                        MLRO / deputy MLRO / compliance officer is?</label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check16" v-model="checkedNumbers[16]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="row justify-content-between">


                <div class="col-2">
                  <div class="d-grid">
                    <a class="btn btn-outline-success" @click.prevent="setActive('risk')"
                      :class="{ active: isActive('risk') }" href="#risk">Previous</a>
                  </div>
                </div>

                <div class="col-2">
                  <div class="d-grid">
                    <a class="btn btn-outline-success" @click.prevent="setActive('cdd')"
                      :class="{ active: isActive('cdd') }" href="#cdd">Next</a>
                  </div>
                </div>

              </div>


            </div>
          </div>
        </div>


        <!-- tab - CDD -->


        <div class="tab-pane fade" :class="{ 'active show': isActive('cdd') }" id="profile">

          <div class="container">
            <div class="row">



              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check17">Q4.1 Does the firm have procedures to check a
                        client’s identity, appropriate with the level of due diligence stated in your risk
                        assessment?</label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check17" v-model="checkedNumbers[17]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check18">Q4.2 If the firm has developed its own CDD
                        procedures do they document client identification, understanding of the client’s activities,
                        understanding the reasons behind the services provided to
                        clients and a conclusion on the level of risk?
                      </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check18" v-model="checkedNumbers[18]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check19">Q4.3 Is the CDD process updated regularly (and
                        immediately for any client on a change in their circumstances)? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check19" v-model="checkedNumbers[19]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check21">Q4.4 Are there controls in place to ensure that
                        CDD is undertaken prior to services being provided to the client? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check21" v-model="checkedNumbers[20]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check22">Q4.5 If the firm has not been able to complete
                        its CDD procedures satisfactorily has it ceased its business relationship with that client?
                      </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check22" v-model="checkedNumbers[21]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>


              <div class="row justify-content-between">


                <div class="col-2">
                  <div class="d-grid">
                    <a class="btn btn-outline-success" @click.prevent="setActive('staff')"
                      :class="{ active: isActive('staff') }" href="#staff">Previous</a>
                  </div>
                </div>

                <div class="col-2">
                  <div class="d-grid">
                    <a class="btn btn-outline-success" @click.prevent="setActive('reporting')"
                      :class="{ active: isActive('reporting') }" href="#reporting">Next</a>
                  </div>
                </div>

              </div>


            </div>
          </div>
        </div>



        <!-- tab reporting -->

        <div class="tab-pane fade" :class="{ 'active show': isActive('reporting') }" id="reporting">

          <div class="container">
            <div class="row">

              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check23">Q5.1 Does the firm keep AML records for at
                        least 5 years after a business relationship with a client ceases? </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check23" v-model="checkedNumbers[22]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check24">Q5.2 Has the firm registered with the
                        Information Commissioner’s Office under the Data Protection legislation?</label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check24" v-model="checkedNumbers[23]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check27">Q5.3 Do you have a documented internal
                        escalation and reporting process for reporting suspicious activities to the MLRO?
                      </label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check27" v-model="checkedNumbers[24]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group my-3 fs-3 text">
                  <div class="d-flex form-switch">
                    <div class="col-11">
                      <label class="form-check-label fs16" for="check28">Q5.4 Have you kept records of any SARs you have
                        made?</label>
                    </div>
                    <div class="col-1">
                      <input class="form-check-input" type="checkbox" id="check28" v-model="amberNumbers[3]"
                        :true-value="redCheck" false-value="0">
                    </div>
                  </div>
                </div>
              </div>




              <div class="row justify-content-between">
                <div class="col-2">
                  <div class="d-grid">
                    <a class="btn btn-outline-success" @click.prevent="setActive('cdd')"
                      :class="{ active: isActive('cdd') }" href="#cdd">Previous</a>
                  </div>
                </div>
                <div class="col-2">
                  <div class="d-grid">
                    <a class="btn btn-outline-success" v-on:click="isHidden = !isHidden">Get your results</a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>




        <!-- Closing brackets for tabs-->
      </div>
    </div>
  </div>


  <!-- results -->

  <div class="container" v-if="isHidden">
    <section class="mt-5" id="results-section">
      <div ref="content" id="results">

        <div class="row">


          <div class="col">
            <h1 class="title-results"> Your results </h1>
          </div>

          <div class="col text-right">
            <button class="btn btn-outline" v-on:click="isHidden = !isHidden">Edit your answers</button>

          </div>
        </div>

        <div class="row gap-2 mb-2">
          <div class="score-box" id="red-score-box">
            <h3>{{ redAlerts }}</h3>
            <h4>Red alerts</h4>
          </div>

          <div class="score-box" id="amber-score-box">
            <h3>{{ amberAlerts }}</h3>
            <h4>Amber alerts</h4>

          </div>

          <div class="score-box" id="passes-score-box">
            <h3>{{ passedAlerts }}</h3>
            <h4>Passes</h4>
          </div>

        </div>


        <div class="row">
          <div v-if="redAlerts > 0" class="col mb-2" id="red-results">
            <h2>Red alerts</h2>
            <h3>Policies</h3>
            <div class="red-point" v-if="!checkedNumbers[0]">You have no written policies, controls and procedures to
              mitigate the risk of money laundering.</div>
            <div class="red-point" v-if="!checkedNumbers[2]">Your policies, controls and procedures do not sufficently
              cover key AML regulations.</div>
            <div class="red-point" v-if="!checkedNumbers[3]">You do not regularly updated your policies, controls and
              procedures and there are not approved by senior management.</div>
            <div class="red-point" v-if="!checkedNumbers[4]">Your policies, controls and procedures have not been made
              available or communicated to staff.</div>
            <div class="red-point" v-if="!checkedNumbers[5]">You have not nominated someone from senior management to be
              responsible for your AML compliance.</div>
            <div class="red-point" v-if="!checkedNumbers[6]">Your nominated officer has not been registered with and
              approved by HMRC.</div>

            <h3>Risk Assessments</h3>
            <div class="red-point" v-if="!checkedNumbers[8]">You have not carried out a risk assessment.</div>
            <div class="red-point" v-if="!checkedNumbers[9]">Your risk assessment is to generic and does consider the
              type of activity you undertake and the clients you deal with.</div>
            <div class="red-point" v-if="!checkedNumbers[11]">You have not updated your risk assessment in the last 12
              months.</div>
            <div class="red-point" v-if="!checkedNumbers[12]">You have not documentated your risk assessment.</div>
            <div class="red-point" v-if="!checkedNumbers[13]">Your risk assessment has not been approved by senior
              management.</div>

            <h3>Staff Training</h3>
            <div class="red-point" v-if="!checkedNumbers[14]">You have not provided adequate training for all staff.
            </div>
            <div class="red-point" v-if="!checkedNumbers[15]">You have not kept a record of staff training.</div>
            <div class="red-point" v-if="!checkedNumbers[16]">You have not made your staff aware of who your MLRO /
              compliance is.</div>



            <h3>Customer Due Diligence </h3>
              <div class="red-point" v-if="!checkedNumbers[17]">Do you do not have procedures in place to check a
                client’s identity.</div>
              <div class="red-point" v-if="!checkedNumbers[18]">Your CDD procedures do not cover the full requirements
                of the regulations.</div>
              <div class="red-point" v-if="!checkedNumbers[19]">Your CDD process is not regularly updated.</div>
              <div class="red-point" v-if="!checkedNumbers[20]">There are no controls in place to ensure CDD processes
                are always undertaken.</div>
              <div class="red-point" v-if="!checkedNumbers[21]">You have continued to work with a client despite failing
                to conduct thorough due diligence .</div>


              <h3>Reporting & Record Keeping </h3>
                <div class="red-point" v-if="!checkedNumbers[22]">You do not keep your AML records for a minimum of 5
                  years.</div>
                <div class="red-point" v-if="!checkedNumbers[23]">You are not registered with the Information
                  Commissioner’s Office.</div>
                <div class="red-point" v-if="!checkedNumbers[24]">There is no internal process for reporting knowledge
                  of suspicious activity.</div>



          </div>
        </div>

        <div class="row">

          <div v-if="amberAlerts > 0" class="col mb-2" id="amber-results">
            <h2>Amber alerts</h2>
            <div class="point" v-if="!amberNumbers[0]">Your policies, controls and procedures maybe to generic. </div>
            <div class="point" v-if="!amberNumbers[1]">Your policies, controls and procedures maybe aren't being
              strictly followed across all departments / businesses within the group.</div>
            <div class="point" v-if="!amberNumbers[2]">You have not considered the high-risk factors disclosed by HMRC.
            </div>
            <div class="point" v-if="!amberNumbers[3]">You have not kept records of all SARs you have made.</div>
          </div>
        </div>


 <div class="row">

          <div class="col mb-1" id="passed-results">
            <h2>Passes</h2>
             <h3>Policies</h3>
            <div class="pass-point" v-if="checkedNumbers[0]">You have written policies, controls and procedures in place to
              mitigate the risk of money laundering.</div>
            <div class="pass-point" v-if="amberNumbers[0]">Your policies, controls and procedures are specific to your circumstances. </div>
            <div class="pass-point" v-if="checkedNumbers[2]">Your policies, controls and procedures sufficently
              cover key AML regulations.</div>
            <div class="pass-point" v-if="checkedNumbers[3]">You regularly updated your policies, controls and
              procedures and there are approved by senior management.</div>
            <div class="pass-point" v-if="checkedNumbers[4]">Your policies, controls and procedures have been made
              available and communicated to staff.</div>
            <div class="pass-point" v-if="checkedNumbers[5]">You have nominated someone from senior management to be
              responsible for your AML compliance.</div>
            <div class="pass-point" v-if="checkedNumbers[6]">Your nominated officer has been registered with and approved by HMRC.</div>
            <div class="pass-point" v-if="amberNumbers[1]">Your policies, controls and procedures are  followed across all departments / businesses within the group.</div>


 <h3>Risk Assessments</h3>
            <div class="pass-point" v-if="checkedNumbers[8]">You have carried out a risk assessment.</div>
            <div class="pass-point" v-if="checkedNumbers[9]">Your risk assessment considers the
              type of activity you undertake and the clients you deal with.</div>
               <div class="pass-point" v-if="amberNumbers[2]">You have considered the high-risk factors disclosed by HMRC.
            </div>
            <div class="pass-point" v-if="checkedNumbers[11]">You have reviewed and updated your risk assessment in the last 12
              months.</div>
            <div class="pass-point" v-if="checkedNumbers[12]">You have documentated your risk assessment.</div>
            <div class="pass-point" v-if="checkedNumbers[13]">Your risk assessment has been approved by senior
              management.</div>

            <h3>Staff Training</h3>
            <div class="pass-point" v-if="checkedNumbers[14]">You have provided adequate training for all staff.
            </div>
            <div class="pass-point" v-if="checkedNumbers[15]">You have kept a record of all staff training.</div>
            <div class="pass-point" v-if="checkedNumbers[16]">You have made your staff aware of who your MLRO /
              compliance is.</div>



            <h3>Customer Due Diligence </h3>
              <div class="pass-point" v-if="checkedNumbers[17]">Do have procedures in place to check a
                client’s identity.</div>
              <div class="pass-point" v-if="checkedNumbers[18]">Your CDD procedure cover the full requirements
                of the regulations.</div>
              <div class="pass-point" v-if="checkedNumbers[19]">Your CDD process is regularly updated.</div>
              <div class="pass-point" v-if="checkedNumbers[20]">There are sufficent controls in place to ensure CDD processes
                are always undertaken.</div>
              <div class="pass-point" v-if="checkedNumbers[21]">You controls in place to stop working clients who not met your due diligence procedures.</div>


              <h3>Reporting & Record Keeping </h3>
                <div class="pass-point" v-if="checkedNumbers[22]">You keep your AML records for a minimum of 5                  years.</div>
                <div class="pass-point" v-if="checkedNumbers[23]">You are registered with the Information Commissioner’s Office.</div>
                <div class="pass-point" v-if="checkedNumbers[24]">There a clear internal process for reporting knowledge
                  of suspicious activity.</div>
                              <div class="pass-point" v-if="amberNumbers[3]">You have kept records of all SARs you have made.</div>



           
          </div>
        </div>

        <div class="row">
          <div class="col small-text">
            Whilst care has been taken in the production of this guide and the information contained within it has been obtained from sources that Credas believes to be reliable, Credas does not warrant, represent or guarantee the accuracy, adequacy, completeness or fitness for any purpose of the guide or any part of it and can accept no liability for any loss incurred in any way whatsoever by any person who may rely on it. In any case any recipient shall be entirely responsible for the use to which it puts this guide.


          </div>
        </div>





      </div>


    </section>
    <section>

      <div class="container">
        <div class="row justify-content-center mt-3">
          <div class="col-md-6 text-center">
            <div>
              <button @click="download" class="btn btn-primary btn-credas">Download Your Results</button>
            </div>

          </div>
        </div>

      </div>


    </section>
  </div>

</template>

<script>


import jsPDF from 'jspdf'
import domtoimage from "dom-to-image";

export default {
  components: {


  },
  data() {
    return {
      checkedNumbers: [],
      amberNumbers: [],
      redCheck: 1,
      isHidden: false,
      activeItem: 'policies',    
    }
  },

  computed: {

    uncheck() {
      return this.checkedNumbers.filter(e => e !== false);
    },
    sum() {
      return this.checkedNumbers.reduce((a, b) => parseInt(a) + parseInt(b), 0);
    },
    redAlerts() {
      return 22 - this.sum;
    },
    uncheckAmber() {
      return this.amberNumbers.filter(e => e !== false);
    },
    amberSum() {
      return this.amberNumbers.reduce((a, b) => parseInt(a) + parseInt(b), 0);
    },
    amberAlerts() {
      return 4 - this.amberSum;
    },
    passedAlerts() {
      return this.amberSum + this.sum;
    }


  },
  methods: {
    download() {

      /** WITH CSS */
      domtoimage
        .toPng(this.$refs.content)
        .then(function (dataUrl) {
          const img = new Image();
          img.src = dataUrl;
          const doc = new jsPDF ('p', 'mm', [647, 210]);
          doc.addImage(img, "JPEG", 10, 10);
          const date = new Date();
          const filename =
            "AML-assessement-Credas_" +
            date.getFullYear() +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            ("0" + date.getDate()).slice(-2) +
            ("0" + date.getHours()).slice(-2) +
            ("0" + date.getMinutes()).slice(-2) +
            ("0" + date.getSeconds()).slice(-2) +
            ".pdf";
          doc.save(filename);
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
        });
    },
    isActive(menuItem) {
      return this.activeItem === menuItem
    },
    setActive(menuItem) {
      this.activeItem = menuItem
    },
  },
 
    myMethod: function() {
      if (this.amberNumbers[0]) console.log("checked");
      else console.log("unchecked");
    }

  }
  


</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
body {
  background: #00142d;
  color: #fff;

}

h1 {
  color: #f9b233;

  font-size: 42px;
  margin-bottom: 16px;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

label {
  font-size: 20px;
  color: #fff;

}

.form-switch label {
  text-align: left;
}

.form-switch .form-check-input {
  margin-left: 1em
}

.form-switch {
  padding: 0;
}


.form-check-input:before {
  content: "no";
  font-size: 12px;
  position: relative;
  top: -15px;
  left: 28px;


}

.form-check-input:checked:before {
  content: "yes";
  font-size: 12px;
  position: relative;
  top: -15px;
  left: 8px;
  color: #fff;

}

.form-check-input:checked {
  background-color: #f9b233;
  border-color: #f9b233;
}


.nav-justified .nav-item,
.nav-justified>.nav-link {
  margin: 0;

}

.nav {
  background: #eee;
  padding: 10px;
  border: none;
  border-radius: 30px;
}

.nav-link {
  border: none;
}

.nav-tabs .nav-link {
  border: none;
  border-radius: 20px;
  border: none;
  background: #eee;
  color: #00142d;
}

.nav-tabs .nav-link.active {
  border-radius: 20px;
  border: none;
  background: #164f9e;
  color: #fff;

}

#results-section {
  display: flex;
  justify-content: center;
}

#results {
  max-width: 720px;
  background: #fff;
  padding: 30px;
}

.text-right {
  text-align: right;
}

.btn-credas {
  border-radius: 200px;
  background: #00142d;
  color: #00142d;
  background: #f9b233;
  border: none;
  padding: 16px 24px;
  font-size: 1.2rem;
}

.btn-credas:hover {

  background: #164f9e;

}

.btn-outline-success {
  color: #fff;
  border: 1px solid #fff;
}


.btn-outline-success:hover {
  background: #164f9e;
  border: 1px solid #164f9e;
}


.score-box {
  padding: 30px;
  text-align: center;
  color: #fff;
  flex: 1 1 30%;
  min-width: 220px;
}

.score-box h3 {
  margin: 0;
  font-size: 36px;
}

.score-box h4 {
  margin: 0;
  font-size: 24px;

}

#red-score-box {
  background: #DC143C;
}

#amber-score-box {
  background: #f9b233;
}

#passes-score-box {
  background: #42b983;

}

.title {
  text-align: center;
}

.title-results {
  color: #00142d;
}


#red-results {
  background: #DC143C;
  padding: 32px;
  color: #fff;

}

#amber-results {
  background: #f9b233;
  padding: 32px;
}



#passed-results {
  background: #42b983;
  padding: 32px;
}

.point {
  margin-bottom: 8px;
  margin-left: 14px;
}

.point:before {
  content: "?";
  margin-left: -14px;
  margin-right: 8px;
}

.pass-point {
  margin-bottom: 8px;
  margin-left: 14px;
}

.pass-point:before{
  content: "✓";
  margin-left: -14px;
  margin-right: 8px;
}



.red-point {
  margin-bottom: 8px;
  margin-left: 14px;
}

.red-point:before {
  content: "!";
  margin-left: -14px;
  margin-right: 8px;
}

.small-text{
  font-size: 11px;
}
</style>
